import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import * as _ from "lodash";
import { makeParams } from 'app/modules-core/utility/helpers';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DiaryService = /** @class */ (function () {
    function DiaryService(http) {
        this.http = http;
        this.urlBase = 'diaries';
        this.httpOptions = {
            params: new HttpParams()
        };
    }
    DiaryService.prototype.getAll = function (opts) {
        if (opts === void 0) { opts = {}; }
        return this.http
            .get("" + this.urlBase, {
            params: makeParams(_.merge({
                httpParams: this.httpOptions.params
            }, { queryParams: opts }))
        })
            .pipe(map(function (resp) { return resp.data; }));
    };
    DiaryService.prototype.getById = function (id) {
        return this.http.get(this.urlBase + "/" + id)
            .pipe(map(function (resp) { return resp.data; }));
    };
    DiaryService.prototype.delete = function (id) {
        return this.http.delete(this.urlBase + "/" + id)
            .pipe(map(function (resp) { return resp.data; }));
    };
    DiaryService.prototype.create = function (data) {
        return this.http.post("" + this.urlBase, data).pipe(map(function (resp) { return resp.data; }));
    };
    DiaryService.prototype.update = function (id, data) {
        return this.http.put(this.urlBase + "/" + id, data).pipe(map(function (resp) { return resp.data; }));
    };
    DiaryService.ngInjectableDef = i0.defineInjectable({ factory: function DiaryService_Factory() { return new DiaryService(i0.inject(i1.HttpClient)); }, token: DiaryService, providedIn: "root" });
    return DiaryService;
}());
export { DiaryService };
